var map = {
	"./app/batch-module/assets/lang/ar.json": "3321",
	"./app/batch-module/assets/lang/en.json": "fa7f",
	"./app/category-module/assets/lang/ar.json": "60e4",
	"./app/category-module/assets/lang/en.json": "af98",
	"./app/core-module/assets/lang/ar.json": "8c71",
	"./app/core-module/assets/lang/en.json": "2d7a",
	"./app/course-module/assets/lang/ar.json": "5e6f",
	"./app/course-module/assets/lang/en.json": "08b8",
	"./app/invoices-module/assets/lang/ar.json": "f440",
	"./app/invoices-module/assets/lang/en.json": "3351",
	"./app/organization-module/assets/lang/ar.json": "b35d",
	"./app/organization-module/assets/lang/en.json": "103b",
	"./app/quiz-module/assets/lang/ar.json": "d6f6",
	"./app/quiz-module/assets/lang/en.json": "d729",
	"./app/reports-module/assets/lang/ar.json": "257f",
	"./app/reports-module/assets/lang/en.json": "39bb",
	"./app/statistics-module/assets/lang/ar.json": "d84d",
	"./app/statistics-module/assets/lang/en.json": "aa59",
	"./app/user-module/assets/lang/ar.json": "c1de",
	"./app/user-module/assets/lang/en.json": "3fb9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "da83";